const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID || "",
      userPoolClientId: process.env.REACT_APP_CLIENT_ID || "",
      loginWith: {
        email: true,
      }
    },
  },
};

export default awsConfig;
